import {
    AutocompleteInput,
    DateInput,
    ReferenceInput,
    required,
    useGetList,
} from 'react-admin';
import { SimpleForm } from '@components/SimpleForm';
import { Grid } from '@mui/material';
import { entityResource as ent } from '@src/entityResource';

export const ScheduleForm = () => {
    const { data: sales, isPending } = useGetList(ent.USER.SALES_API);

    return (
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <DateInput source="visitDate" validate={[required()]} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <AutocompleteInput
                        source="userId"
                        optionText="name"
                        optionValue="id"
                        isPending={isPending}
                        choices={sales}
                        validate={[required()]}
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    <ReferenceInput source="storeId" reference="store">
                        <AutocompleteInput
                            optionText="name"
                            validate={[required()]}
                        />
                    </ReferenceInput>
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
